<div class="main-page">
  <app-header></app-header>
  <div class="container">
    <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
    
    <!-- Jobs List View -->
    <div *ngIf="!showCreateForm" class="plans-area">
      <div class="innerPage plans-area-inner">
        <div class="jobs-header">
          <h2 class="jobs-title">Jobs</h2>
          <div class="jobs-header-actions">
            <button type="button" class="btn-search" (click)="toggleCreateForm()">
              <i class="fas fa-search"></i> Search
            </button>
            <button type="button" class="btn-add-job" (click)="toggleCreateForm()">
              <i class="fas fa-plus"></i> Add Job
            </button>
            <button type="button" class="btn-all-jobs">
              <i class="fas fa-chevron-down"></i> All Jobs
            </button>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="jobs?.length === 0" class="jobs-empty">
          <img class="jobs-empty-img" src="../../assets/no-data.png" alt="No jobs available" />
          <h5 class="jobs-empty-title">No Jobs Available</h5>
          <p class="jobs-empty-subtitle">Create your first job posting to get started.</p>
          <button (click)="toggleCreateForm()" class="btn-add-job btn-add-job--empty">
            <i class="fas fa-plus"></i> Add Job
          </button>
        </div>

        <!-- Jobs Grid -->
        <div *ngIf="jobs?.length > 0" class="jobs-grid">
          <div class="job-card job-card-listing" *ngFor="let job of pagedJobs; let i = index" (click)="openJobDetails(jobDetailsModal, job)" style="cursor: pointer;">
            <div class="job-card-badges">
              <span class="job-badge job-badge--expired" *ngIf="isJobExpired(job?.activeTill)">
                EXPIRED
              </span>
              <span class="job-badge job-badge--active" *ngIf="!isJobExpired(job?.activeTill)">
                ACTIVE
              </span>
              <i class="far fa-heart job-heart" (click)="$event.stopPropagation()"></i>
            </div>
            
            <div class="job-card-content">
              <h3 class="job-title job-title-listing">{{ job?.jobBasics?.title || 'Untitled Job' }}</h3>
              
              <div class="job-details job-details-listing">
                <div class="job-header-info">
                  <div class="job-detail-item job-type">
                    <span class="job-type-label">{{ job?.jobDetails?.jobType || 'Full-time' }}</span>
                  </div>
                  <div class="job-company-info" *ngIf="job?.jobPost?.companyName">
                    <i class="fas fa-briefcase"></i>
                    <span>{{ job.jobPost.companyName }}</span>
                  </div>
                  <div class="job-company-info" *ngIf="job?.jobBasics?.industry">
                    <i class="fas fa-building"></i>
                    <span>{{ job.jobBasics.industry }}</span>
                  </div>
                </div>

                <div class="job-specs">
                  <div class="job-spec-item" *ngIf="job?.jobDetails?.jobPay">
                    <span class="spec-value">${{ job.jobDetails.jobPay }}</span>
                    <span class="spec-label">Salary</span>
                  </div>
                  <div class="job-spec-item" *ngIf="job?.jobBasics?.remoteJob === 'Yes'">
                    <span class="spec-value">Remote</span>
                    <span class="spec-label">Type</span>
                  </div>
                </div>

                <div class="job-location" *ngIf="getJobLocation(job) !== '-'">
                  <i class="fas fa-map-marker-alt"></i>
                  <span>{{ getJobLocation(job) }}</span>
                </div>

                <div class="job-additional-info">
                  <div class="info-item" *ngIf="job?.jobPost?.email">
                    <i class="fas fa-envelope"></i>
                    <span>{{ job.jobPost.email }}</span>
                  </div>
                  <div class="info-item" *ngIf="job?.jobPost?.phoneNumber">
                    <i class="fas fa-phone"></i>
                    <span>{{ job.jobPost.phoneNumber }}</span>
                  </div>
                  <div class="info-item" *ngIf="job?.applicationSettings?.receiveType">
                    <i class="fas fa-paper-plane"></i>
                    <span>Apply via {{ job.applicationSettings.receiveType }}</span>
                  </div>
                  <div class="info-item" *ngIf="job?.applicationSettings?.receiveValue">
                    <i class="fas fa-link"></i>
                    <span>{{ job.applicationSettings.receiveValue }}</span>
                  </div>
                </div>

                <div class="job-description" *ngIf="job?.jobDetails?.jobDuties">
                  <p>{{ (job.jobDetails.jobDuties.length > 100) ? (job.jobDetails.jobDuties | slice:0:100) + '...' : job.jobDetails.jobDuties }}</p>
                </div>

                <div class="job-date" *ngIf="job?.activeTill">
                  <i class="fas fa-calendar-alt"></i>
                  <span>Until {{ formatDate(job.activeTill) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div class="jobs-pagination job-pagination" *ngIf="jobs?.length > 0 && totalPages > 1">
          <button class="page-btn" (click)="prevPage()" [disabled]="page <= 1" [attr.aria-label]="'Previous page'">
            <i class="fas fa-chevron-left"></i> Previous
          </button>
          <span class="page-info">
            Page <strong>{{ page }}</strong> of <strong>{{ totalPages }}</strong>
          </span>
          <button class="page-btn" (click)="nextPage()" [disabled]="page >= totalPages" [attr.aria-label]="'Next page'">
            Next <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Create Job Form View -->
    <div *ngIf="showCreateForm" class="plans-area">
      <div class="innerPage plans-area-inner">
        <div class="responsive">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                        <div class="event-heading">
                          <span>{{ isEditMode ? 'Update Job' : 'Create Job' }}</span>
                          <button type="button" class="btn-back" (click)="cancel()">
                            <i class="fas fa-arrow-left"></i> Back to Jobs
                          </button>
                        </div>
                        
                        <!-- Job Post Section -->
                        <div class="section-container">
                          <h5 class="section-title">Job Post Information</h5>
                          
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Company Name <span class="required">*</span></label>
                                <input type="text" class="form-control" formControlName="companyName"
                                  placeholder="Company Name"
                                  [ngClass]="{'is-invalid': submitted && f.companyName.errors}">
                                <div *ngIf="submitted && f.companyName.errors" class="invalid-feedback">
                                  Company name is required
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Your Name <span class="required">*</span></label>
                                <input type="text" class="form-control" formControlName="name"
                                  placeholder="Your Name"
                                  [ngClass]="{'is-invalid': submitted && f.name.errors}">
                                <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                  Name is required
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Email <span class="required">*</span></label>
                                <input type="email" class="form-control" formControlName="email"
                                  placeholder="Email"
                                  [ngClass]="{'is-invalid': submitted && f.email.errors}">
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                  <div *ngIf="f.email.errors.required">Email is required</div>
                                  <div *ngIf="f.email.errors.email">Please enter a valid email</div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Role</label>
                                <select class="form-control" formControlName="role">
                                  <option *ngFor="let role of roleOptions" [value]="role">{{role}}</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Phone Number</label>
                                <input type="text" class="form-control" formControlName="phoneNumber"
                                  placeholder="Phone Number">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Company Website</label>
                                <input type="text" class="form-control" formControlName="companyWebsite"
                                  placeholder="https://example.com">
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="form-label">Company Values</label>
                            <textarea class="form-control" formControlName="companyValues" rows="3"
                              placeholder="Company Values"></textarea>
                          </div>

                          <div class="privacy-settings">
                            <h6 class="privacy-title">Privacy Settings</h6>
                            <div class="row">
                              <div class="col-md-3">
                                <label class="checkbox-label">
                                  <input type="checkbox" formControlName="NamePrivacy">
                                  <span>Hide Name</span>
                                </label>
                              </div>
                              <div class="col-md-3">
                                <label class="checkbox-label">
                                  <input type="checkbox" formControlName="EmailPrivacy">
                                  <span>Hide Email</span>
                                </label>
                              </div>
                              <div class="col-md-3">
                                <label class="checkbox-label">
                                  <input type="checkbox" formControlName="PhonePrivacy">
                                  <span>Hide Phone</span>
                                </label>
                              </div>
                              <div class="col-md-3">
                                <label class="checkbox-label">
                                  <input type="checkbox" formControlName="companyWebsitePrivacy">
                                  <span>Hide Website</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Job Basics Section -->
                        <div class="section-container">
                          <h5 class="section-title">Job Basics</h5>
                          
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Job Title <span class="required">*</span></label>
                                <input type="text" class="form-control" formControlName="title"
                                  placeholder="Job Title"
                                  [ngClass]="{'is-invalid': submitted && f.title.errors}">
                                <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                                  Job title is required
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Industry</label>
                                <select class="form-control" formControlName="industry">
                                  <option *ngFor="let industry of industryOptions" [value]="industry">{{industry}}</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Category</label>
                                <input type="text" class="form-control" formControlName="category"
                                  placeholder="Job Category">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Remote Job</label>
                                <select class="form-control" formControlName="remoteJob">
                                  <option *ngFor="let option of remoteJobOptions" [value]="option">{{option}}</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="form-group" formGroupName="location">
                            <label class="form-label">Job Location</label>
                            <app-auto (setAddress)="onLocationChange($event)" 
                              [strictBounds]="boundsLimit" 
                              [LatLng]="defaultBounds"
                              adressType="geocode" 
                              title="Job Location">
                            </app-auto>
                            <div class="mt-2" *ngIf="!hasGoogleSelection || !(form?.get('location.location.coordinates')?.value && form?.get('location.location.coordinates')?.value.length === 2)">
                              <small class="text-danger">Please select a location from Google suggestions.</small>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <label class="checkbox-label">
                                <input type="checkbox" formControlName="isAddress">
                                <span>Show Address</span>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label class="checkbox-label">
                                <input type="checkbox" formControlName="isContact">
                                <span>Show Contact Information</span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <!-- Job Details Section -->
                        <div class="section-container">
                          <h5 class="section-title">Job Details</h5>
                          
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Job Type</label>
                                <select class="form-control" formControlName="jobType">
                                  <option *ngFor="let type of jobTypeOptions" [value]="type">{{type}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Job Pay</label>
                                <input type="text" class="form-control" formControlName="jobPay"
                                  placeholder="e.g., $50,000 - $70,000">
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="form-label">Job Duties & Responsibilities</label>
                            <textarea class="form-control" formControlName="jobDuties" rows="5"
                              placeholder="Describe the job duties and responsibilities"></textarea>
                          </div>

                          <div class="form-group">
                            <label class="form-label">Required Skills</label>
                            <textarea class="form-control" formControlName="skills" rows="3"
                              placeholder="List required skills"></textarea>
                          </div>
                        </div>

                        <!-- Recruiting Address Section -->
                        <div class="section-container" formGroupName="recruitingAddress">
                          <h5 class="section-title">Recruiting Address</h5>
                          
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Address</label>
                                <input type="text" class="form-control" 
                                  formControlName="address"
                                  placeholder="Street Address">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">City</label>
                                <input type="text" class="form-control" 
                                  formControlName="city"
                                  placeholder="City">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <label class="form-label">State</label>
                                <input type="text" class="form-control" 
                                  formControlName="state"
                                  placeholder="State">
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label class="form-label">Postal Code</label>
                                <input type="text" class="form-control" 
                                  formControlName="postalCode"
                                  placeholder="Postal Code">
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label class="form-label">Country</label>
                                <input type="text" class="form-control" 
                                  formControlName="country"
                                  placeholder="Country">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Contact Number</label>
                                <input type="text" class="form-control" 
                                  formControlName="contactNumber"
                                  placeholder="Contact Number">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-4">
                              <label class="checkbox-label">
                                <input type="checkbox" formControlName="currentRegionStatus">
                                <span>Limit to Current Region</span>
                              </label>
                            </div>
                            <div class="col-md-4">
                              <label class="checkbox-label">
                                <input type="checkbox" formControlName="addressStatus">
                                <span>Show Address</span>
                              </label>
                            </div>
                            <div class="col-md-4">
                              <label class="checkbox-label">
                                <input type="checkbox" formControlName="contactStatus">
                                <span>Show Contact</span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <!-- Application Settings Section -->
                        <div class="section-container" formGroupName="applicationSettings">
                          <h5 class="section-title">Application Settings</h5>
                          
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">How to Receive Applications <span class="required">*</span></label>
                                <select class="form-control" formControlName="receiveType">
                                  <option *ngFor="let type of receiveTypeOptions" [value]="type">{{type}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Contact Information <span class="required">*</span></label>
                                <input type="text" class="form-control" 
                                  formControlName="receiveValue"
                                  [placeholder]="getPlaceholderText()"
                                  [ngClass]="{'is-invalid': submitted && form.get('applicationSettings.receiveValue')?.errors}">
                                <div *ngIf="submitted && form.get('applicationSettings.receiveValue')?.errors" class="invalid-feedback">
                                  Contact information is required
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Required Documents</label>
                                <input type="text" class="form-control" 
                                  formControlName="documents"
                                  placeholder="e.g., Resume, Cover Letter">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Duration (days)</label>
                                <input type="number" class="form-control" 
                                  formControlName="duration"
                                  placeholder="Job posting duration">
                              </div>
                            </div>
                          </div>

                        </div>

                        <!-- Submit Buttons -->
                        <div class="form-actions">
                          <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
                          <button type="submit" class="btn btn-primary">{{ isEditMode ? 'Update Job' : 'Create Job' }}</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Job Details Modal -->
  <ng-template #jobDetailsModal let-modal>
    <div class="modal-header job-modal-header">
      <h4 class="modal-title" id="job-details-modal">Job Details</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body job-modal-body" *ngIf="selectedJob">
      <!-- Job Status and Title -->
      <div class="job-detail-header">
        <div class="job-detail-title-section">
          <h3 class="job-detail-title">{{ selectedJob?.jobBasics?.title || 'Untitled Job' }}</h3>
          <p class="job-detail-company">{{ selectedJob?.jobPost?.companyName || '-' }}</p>
        </div>
        <div class="job-detail-badges">
          <span class="job-badge job-badge--expired" *ngIf="isJobExpired(selectedJob?.activeTill)">
            Expired
          </span>
          <span class="job-badge job-badge--active" *ngIf="!isJobExpired(selectedJob?.activeTill)">
            Active
          </span>
          <span class="job-badge job-badge--remote" *ngIf="selectedJob?.jobBasics?.remoteJob === 'Yes'">
            Remote
          </span>
        </div>
      </div>

      <!-- Job Information Grid -->
      <div class="job-detail-grid">
        <div class="job-detail-section">
          <h5 class="job-detail-section-title">Job Information</h5>
          <div class="job-detail-item">
            <i class="fas fa-briefcase"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Company</span>
              <span class="job-detail-value">{{ selectedJob?.jobPost?.companyName || '-' }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.jobBasics?.industry">
            <i class="fas fa-building"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Industry</span>
              <span class="job-detail-value">{{ selectedJob.jobBasics.industry }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.jobBasics?.category">
            <i class="fas fa-tag"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Category</span>
              <span class="job-detail-value">{{ selectedJob.jobBasics.category }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.jobDetails?.jobType">
            <i class="fas fa-user-tie"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Job Type</span>
              <span class="job-detail-value">{{ selectedJob.jobDetails.jobType }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.jobDetails?.jobPay">
            <i class="fas fa-dollar-sign"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Salary</span>
              <span class="job-detail-value">${{ selectedJob.jobDetails.jobPay }}</span>
            </div>
          </div>
          <div class="job-detail-item">
            <i class="fas fa-map-marker-alt"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Location</span>
              <span class="job-detail-value">{{ getJobLocation(selectedJob) }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.activeTill">
            <i class="fas fa-calendar-alt"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Active Until</span>
              <span class="job-detail-value">{{ formatDate(selectedJob.activeTill) }}</span>
            </div>
          </div>
        </div>

        <div class="job-detail-section">
          <h5 class="job-detail-section-title">Job Description</h5>
          <div class="job-detail-item" *ngIf="selectedJob?.jobDetails?.jobDuties">
            <div class="job-detail-item-content">
              <span class="job-detail-label">Duties & Responsibilities</span>
              <p class="job-detail-text">{{ selectedJob.jobDetails.jobDuties }}</p>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.jobDetails?.skills">
            <div class="job-detail-item-content">
              <span class="job-detail-label">Required Skills</span>
              <p class="job-detail-text">{{ selectedJob.jobDetails.skills }}</p>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.jobPost?.companyValues">
            <div class="job-detail-item-content">
              <span class="job-detail-label">Company Values</span>
              <p class="job-detail-text">{{ selectedJob.jobPost.companyValues }}</p>
            </div>
          </div>
        </div>

        <div class="job-detail-section">
          <h5 class="job-detail-section-title">Recruiting Information</h5>
          <div class="job-detail-item" *ngIf="getFullAddress(selectedJob) !== '-'">
            <i class="fas fa-map-marker-alt"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Recruiting Address</span>
              <span class="job-detail-value">{{ getFullAddress(selectedJob) }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.recruitingAddress?.contactNumber">
            <i class="fas fa-phone"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Contact Number</span>
              <span class="job-detail-value">{{ selectedJob.recruitingAddress.contactNumber }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.applicationSettings?.receiveType">
            <i class="fas fa-envelope"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Application Method</span>
              <span class="job-detail-value">{{ selectedJob.applicationSettings.receiveType }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.applicationSettings?.receiveValue">
            <i class="fas fa-info-circle"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Contact Information</span>
              <span class="job-detail-value">{{ selectedJob.applicationSettings.receiveValue }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.applicationSettings?.documents">
            <i class="fas fa-file-alt"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Required Documents</span>
              <span class="job-detail-value">{{ selectedJob.applicationSettings.documents }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedJob?.applicationSettings?.duration">
            <i class="fas fa-clock"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Posting Duration</span>
              <span class="job-detail-value">{{ selectedJob.applicationSettings.duration }} days</span>
            </div>
          </div>
        </div>

        <div class="job-detail-section">
          <h5 class="job-detail-section-title">Contact Information</h5>
          <div class="job-detail-item">
            <i class="fas fa-user"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Poster Name</span>
              <span class="job-detail-value">{{ selectedJob?.jobPost?.name || '-' }}</span>
            </div>
          </div>
          <div class="job-detail-item">
            <i class="fas fa-user-tag"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Role</span>
              <span class="job-detail-value">{{ selectedJob?.jobPost?.role || '-' }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="!selectedJob?.jobPost?.EmailPrivacy && selectedJob?.jobPost?.email">
            <i class="fas fa-envelope"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Email</span>
              <span class="job-detail-value">{{ selectedJob.jobPost.email }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="!selectedJob?.jobPost?.PhonePrivacy && selectedJob?.jobPost?.phoneNumber">
            <i class="fas fa-phone"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Phone</span>
              <span class="job-detail-value">{{ selectedJob.jobPost.phoneNumber }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="!selectedJob?.jobPost?.companyWebsitePrivacy && selectedJob?.jobPost?.companyWebsite">
            <i class="fas fa-globe"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Website</span>
              <span class="job-detail-value">
                <a [href]="selectedJob.jobPost.companyWebsite" target="_blank">{{ selectedJob.jobPost.companyWebsite }}</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer job-modal-footer">
      <button type="button" class="btn btn-primary" (click)="editJob(selectedJob); modal.dismiss('Edit click')">
        <i class="fas fa-edit"></i> Edit Job
      </button>
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">Close</button>
    </div>
  </ng-template>
</div>
